module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraBlack.b390d804.eot";